const cities = [
  { name: "Гуанчжоу", region: "Guangzhou · Экспортный хаб", hub: true },
  { name: "Ханчжоу", region: "Hangzhou · Штаб-квартира", hub: true },
  { name: "Нинбо", region: "Ningbo · Порт отгрузки", hub: true },
  { name: "Шанхай", region: "Shanghai · Логистика", hub: false },
  { name: "Пекин", region: "Beijing · Представительство", hub: false },
  { name: "Шэньчжэнь", region: "Shenzhen · Таможня", hub: false },
  { name: "Тяньцзинь", region: "Tianjin · Порт", hub: false },
  { name: "Чэнду", region: "Chengdu · Западный хаб", hub: false },
  { name: "Ухань", region: "Wuhan · Центральный хаб", hub: false },
  { name: "Сиань", region: "Xi'an · Северо-запад", hub: false },
  { name: "Тайчжоу", region: "Taizhou · Кластер MIC", hub: false },
  { name: "Даньян", region: "Danyang · Оптика/Кузов", hub: false },
  { name: "Юйхуань", region: "Yuhuan · Подвеска", hub: false },
  { name: "Чунцин", region: "Chongqing · Юго-запад", hub: false },
  { name: "Циндао", region: "Qingdao · Морской порт", hub: false },
];

const routes = [
  {
    icon: "ri-truck-line",
    code: "Авто",
    title: "Западный / Восточный коридор",
    subtitle: "Автомобильный транспорт",
    desc: "Прямые фуры Гуанчжоу → Москва через Казахстан (Западный) и Монголию (Восточный). Срок: 18–25 дней.",
    color: "#C9A84C",
    badge: "Авто",
  },
  {
    icon: "ri-train-line",
    code: "Ж/Д Экспресс",
    title: "Китайско-Европейский экспресс",
    subtitle: "Железнодорожный транспорт",
    desc: "Блок-поезда из Ханчжоу / Гуанчжоу через Маньчжурию и Забайкальск до Москвы. Срок: 14–18 дней.",
    color: "#E8C96A",
    badge: "Ж/Д",
  },
  {
    icon: "ri-ship-line",
    code: "Интермодаль",
    title: "Морско-железнодорожный",
    subtitle: "Интермодальная перевозка",
    desc: "Контейнер из Нинбо / Гуанчжоу морем до Владивостока, далее ж/д до Москвы. Срок: 28–35 дней.",
    color: "#A8D8EA",
    badge: "Море+Ж/Д",
  },
];

const hubs = [
  { city: "Гуанчжоу", en: "Guangzhou", role: "Экспортный хаб · Таможня КНР", icon: "ri-building-4-line" },
  { city: "Ханчжоу", en: "Hangzhou", role: "Операционный штаб · Консолидация", icon: "ri-home-office-line" },
  { city: "Нинбо", en: "Ningbo", role: "Морской порт · LCL-сборка", icon: "ri-anchor-line" },
  { city: "Москва", en: "Moscow", role: "Таможня РФ · Финальная доставка", icon: "ri-map-pin-2-line" },
];

export default function AboutNetworkSection() {
  return (
    <section id="network" className="bg-[#060A10] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* ── HEADER ── */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">30 лет · 15 узлов КНР</span>
          </div>
          <h2
            className="text-white mb-5"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(36px, 5vw, 64px)", letterSpacing: "0.03em" }}
          >
            ИНФРАСТРУКТУРА КНР:<br />
            <span className="text-[#C9A84C]">15 УЗЛОВЫХ ТОЧЕК ЦЕПОЧКИ ПОСТАВОК</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl leading-relaxed">
            Опираясь на более чем 30-летний опыт работы в сфере автозапчастей,{" "}
            <strong className="text-white">YAXIN LIANPEI (г. Ханчжоу)</strong> выступает главным операционным штабом.{" "}
            <strong className="text-white">GUANGZHOU CHIRUN (г. Гуанчжоу)</strong> берёт на себя полное управление глобальным экспортом и логистикой.
            Остальные узлы формируют плотную сеть продаж и регионального обслуживания по всей территории КНР.
          </p>
        </div>

        {/* ── CITIES GRID ── */}
        <div className="mb-20">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {cities.map((city) => (
              <div
                key={city.name}
                className={`relative p-4 rounded-sm border transition-all duration-200 ${
                  city.name === "Гуанчжоу" || city.name === "Ханчжоу"
                    ? "bg-gradient-to-br from-[#C9A84C]/10 to-[#0D1420] border-[#C9A84C]/50"
                    : "bg-[#0D1420] border-[#1E2A3A] hover:border-[#C9A84C]/30"
                }`}
              >
                {(city.name === "Гуанчжоу" || city.name === "Ханчжоу") && (
                  <div className="absolute top-2 right-2 w-2 h-2 bg-[#C9A84C] rounded-full animate-pulse"></div>
                )}
                <div className="flex items-center gap-2 mb-1">
                  <i className={`ri-map-pin-line text-sm ${city.name === "Гуанчжоу" || city.name === "Ханчжоу" ? "text-[#C9A84C]" : "text-gray-500"}`}></i>
                  <span className={`font-bold text-sm ${city.name === "Гуанчжоу" || city.name === "Ханчжоу" ? "text-white" : "text-gray-300"}`}>{city.name}</span>
                </div>
                <div className="text-gray-600 text-[10px] leading-tight">{city.region}</div>
                {(city.name === "Гуанчжоу" || city.name === "Ханчжоу") && (
                  <div className="text-[#C9A84C] text-[10px] font-semibold mt-1 uppercase tracking-wide">Хаб</div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════════
            МУЛЬТИМОДАЛЬНЫЕ МАРШРУТЫ И LCL-ХАБЫ
        ══════════════════════════════════════════════════════════ */}
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">
              Мультимодальные маршруты и LCL-хабы
            </span>
          </div>

          {/* 3D Map Background Block */}
          <div className="relative rounded-sm overflow-hidden mb-10" style={{ minHeight: "480px" }}>
            {/* Background image — 3D Eurasia logistics map */}
            <img
              src="https://public.readdy.ai/ai/img_res/2b78685c145409bb0ab3940e5405506b.jpg"
              alt="Мультимодальные маршруты Китай-Россия: Ханчжоу Гуанчжоу — Москва, логистические хабы YAXIN LIANPEI"
              title="Логистические маршруты YAXIN LIANPEI: Hangzhou Guangzhou to Moscow"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            {/* Dark overlay for readability */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#060A10]/90 via-[#060A10]/60 to-[#060A10]/40"></div>

            {/* Content overlay */}
            <div className="relative z-10 p-8 md:p-12 flex flex-col justify-between h-full" style={{ minHeight: "480px" }}>
              <div>
                <h3
                  className="text-white mb-2"
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(28px, 3.5vw, 48px)", letterSpacing: "0.04em" }}
                >
                  МУЛЬТИМОДАЛЬНЫЕ МАРШРУТЫ
                </h3>
                <h4
                  className="text-[#C9A84C] mb-8"
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(18px, 2.5vw, 30px)", letterSpacing: "0.06em" }}
                >
                  И LCL-ХАБЫ · КИТАЙ → РОССИЯ
                </h4>

                {/* Route Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl">
                  {routes.map((r) => (
                    <div
                      key={r.code}
                      className="bg-[#060A10]/80 border border-[#1E2A3A] hover:border-[#C9A84C]/50 p-5 rounded-sm transition-all duration-200 backdrop-blur-sm"
                    >
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-8 h-8 flex items-center justify-center">
                          <i className={`${r.icon} text-xl`} style={{ color: r.color }}></i>
                        </div>
                        <span
                          className="text-[10px] font-bold tracking-[0.2em] uppercase px-2 py-0.5 rounded-sm"
                          style={{ color: r.color, background: `${r.color}18`, border: `1px solid ${r.color}40` }}
                        >
                          {r.badge}
                        </span>
                      </div>
                      <div className="text-white font-bold text-sm mb-0.5" style={{ fontFamily: "'Oswald', sans-serif" }}>
                        {r.title}
                      </div>
                      <div className="text-gray-500 text-[10px] uppercase tracking-wide mb-2">{r.subtitle}</div>
                      <p className="text-gray-400 text-xs leading-relaxed">{r.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Hub chain */}
              <div className="mt-8">
                <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.3em] uppercase mb-4">
                  Узлы консолидации (LCL-хабы)
                </div>
                <div className="flex flex-wrap items-center gap-2">
                  {hubs.map((h, idx) => (
                    <div key={h.city} className="flex items-center gap-2">
                      <div className="flex items-center gap-2 bg-[#0D1420]/90 border border-[#C9A84C]/30 px-3 py-2 rounded-sm backdrop-blur-sm">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                          <i className={`${h.icon} text-[#C9A84C] text-sm`}></i>
                        </div>
                        <div>
                          <div className="text-white text-xs font-bold whitespace-nowrap">{h.city}</div>
                          <div className="text-gray-500 text-[9px] whitespace-nowrap">{h.en}</div>
                        </div>
                      </div>
                      {idx < hubs.length - 1 && (
                        <i className="ri-arrow-right-line text-[#C9A84C]/50 text-sm flex-shrink-0"></i>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── KEY STATS ── */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { value: "30+", label: "Лет на рынке", sub: "С 1994 года" },
            { value: "15", label: "Узлов в КНР", sub: "Полное покрытие цепочки" },
            { value: "3", label: "Юридических лица", sub: "КНР · Россия · Гонконг" },
            { value: "100%", label: "Белая таможня", sub: "ГТД/НДС · EAC · Честный ЗНАК" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-[#0D1420] border border-[#1E2A3A] p-6 rounded-sm text-center hover:border-[#C9A84C]/30 transition-colors"
            >
              <div
                className="text-[#C9A84C] font-black mb-1"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(28px, 3.5vw, 44px)", letterSpacing: "0.04em" }}
              >
                {stat.value}
              </div>
              <div className="text-white text-sm font-semibold mb-1">{stat.label}</div>
              <div className="text-gray-500 text-xs">{stat.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
